<script lang="ts">
  export interface NotificationDialogProps {
    title: string
    description?: string
    options?: {
      forceRefresh: boolean
    }
  }
</script>

<script setup lang="ts">
  import { ref } from 'vue'

  const props = ref<NotificationDialogProps | undefined>(undefined)

  const isOpen = ref(false)

  function showDialog(dialogProps: NotificationDialogProps) {
    isOpen.value = true
    props.value = dialogProps
  }

  function refreshPage() {
    window.location.reload()
  }

  defineExpose({
    showDialog
  })
</script>
<template>
  <gat-alert-dialog
    :open="isOpen"
    :title="props?.title"
    :text="props?.description"
    type="default"
  >
    <template #footer>
      <div
        v-if="props?.options?.forceRefresh"
        class="flex grow items-center gap-4"
      >
        <div class="text-soft text-sm">
          You will need to refresh the page to continue.
        </div>
        <gat-button class="ml-auto" @click="refreshPage()"
          >Refresh Page</gat-button
        >
      </div>
      <gat-button v-else class="ml-auto" variant="ghost" @click="isOpen = false"
        >Close</gat-button
      >
    </template>
  </gat-alert-dialog>
</template>
